import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import PatrickHandRegular from "./PatrickHand-Regular.woff2";

export const PatrickHandFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: PatrickHandRegular,
    descriptors: {
      weight: "400",
      style: "normal",
    },
  },
];
